<div class="inventory">
  <div class="table-actions">
    <app-inventory-filters class="full-width" [pageFilters]="pageFilters"></app-inventory-filters>
  </div>

  <div class="table-header">
    @if (totalItems > -1) {
      <div class="resources-amount">
        {{ 'common.found' | labelsProvider }} {{ totalItems | number }}
        {{ 'resources' }}
      </div>
    }
    <div class="table-header-right">
      <app-columns-selection
        class="columns-selection"
        [columns]="columns()"
        [pageName]="pageName"
        (columnsSelected)="columnsSelected($event)"
      />

      @if (accessService.renderExportCSVButton(accountCategory$ | async)) {
        <div class="export-button-container">
          <app-inventory-export
            [selectedFilters]="pageFilters.getSelectedFilters()"
            [sort]="pageFilters.sortedColumn$.value"
          >
          </app-inventory-export>
        </div>
      }
    </div>
  </div>
  <div class="table">
    <app-inventory-vertical-filters
      [ngClass]="{ 'filters-all': isFiltersMenuOpen }"
      (optionOnSelection)="tablesFiltersChange($event)"
      [pageFilters]="pageFilters"
      [isFiltersMenuOpen]="isFiltersMenuOpen"
      (filtersOnMenuStateChange)="filtersOnMenuStateChange($event)"
    >
    </app-inventory-vertical-filters>
    <app-prime-table
      #table
      [ngClass]="!isFiltersMenuOpen ? 'table-collapsed-menu' : 'table-component'"
      queryParamProperty="resource"
      [data$]="inventoryResourcesCurrentPage$"
      [rowsPerPage]="defaultPageSize"
      [columns]="columns()"
      [isLoading]="(isLoading$ | async) === true"
      [withCheckboxSelection]="false"
      [sortedColumn$]="pageFilters.sortedColumn$"
      [pageInfo]="pageInfo$.value"
      (pageOnChange)="onPagination($event)"
      (rowSelected)="rowSelected($event)"
      (rowUnselected)="rowUnselected()"
      (rowActionOnClick)="actionOnClick($event)"
      tableNotFoundText="You don't have any resources"
      tableNotFoundIcon="assets/images/common/no-results-found.svg"
    />
  </div>
</div>
